export { AppLayout } from '~/common/components/layout/AppLayout';
export type { LoginUserInfoForAppLayout } from '~/common/components/layout/AppLayout';
